<template>

  <section class="pD">
    <div v-for="(single, slug) in portfolioDetail" :key="slug" class="pD__single">
      <div class="pD__single__hero">
        <a class="pD__single__hero__back" @click="$router.go(-1)">Back</a>
        <div class="pD__single__hero__what">{{ single.what }}</div>
        <h1 class="pD__single__hero__title">{{ single.title }}</h1>
        <div v-if="single.image" class="pD__single__hero__cover">
          <img :src="single.image" :alt="single.title">
        </div>
      </div>
      <aside class="pD__single__side">
        <a class="pD__single__side__back" @click="$router.go(-1)">Back</a>
        <div v-if="single.field" class="pD__single__side__container">
          <div class="pD__single__side__container__title">Field</div>
          <div class="pD__single__side__container__content">{{ single.field }}</div>
        </div>
        <div v-if="single.teams" class="pD__single__side__container">
          <div class="pD__single__side__container__title">Team</div>
          <div v-for="(team, index) in single.teams" :key="index" class="pD__single__side__container__content">{{ team.team }}</div>
        </div>
        <div v-if="single.time" class="pD__single__side__container">
          <div class="pD__single__side__container__title">Time</div>
          <div class="pD__single__side__container__content">{{ single.time }}</div>
        </div>
        <div v-if="single.tags" class="pD__single__side__container">
          <div class="pD__single__side__container__title">Tags</div>
          <div v-if="single.tags" class="pD__single__side__container__content">
            <div v-for="(tag, index) in single.tags" :key="index" class="pD__single__side__container__content__single">{{ tag.name }}</div>
          </div>
        </div>
      </aside>
      <div class="pD__single__content">
        <h2 class="pD__single__content__excerpt" v-if="single.excerpt" v-html="single.excerpt"></h2>
        <div class="pD__single__content__body content-text" v-html="single.content"></div>
      </div>
    </div>
  </section>

</template>

<script>

  import PostService from '../PostService'
  const postService = new PostService()

  export default {
    name: 'PortfolioList',
    methods: {
      backAndScroll() {
        document.body.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    data() {
      return {
        portfolioDetail: {},
        routeSlug: this.$route.params.slug
      }
    },
    created() {
      postService.getAllPosts()
        .then(result => {

          let filteredPortfolio = result.data.filter(single => {
            return single.slug == this.routeSlug
          })
          
          this.portfolioDetail = filteredPortfolio
        })
        // eslint-disable-next-line
        .catch(error => console.error(error))
    }
  }

</script>

<style scoped lang="scss">

  @import '@/scss/app.scss';

  .pD__single {
    @include container;
    align-items: flex-start;
    flex-wrap: wrap;
    justify-content: space-between;

    @include mq(small) {
      padding-top: 90px;
    }
  }

  .pD__single__hero {
    width: 100%;
    margin-bottom: 50px;

    @include mq(small) {
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      order: 1;
      position: relative;
    }
  }

  .pD__single__hero__back,
  .pD__single__side__back {
    @include ui;
    background: linear-gradient(0deg, $azure 0%, $azure 30%, transparent 31%, transparent 100%);
    cursor: pointer;
    display: block;
    line-height: 20px;
    margin-bottom: 30px;
    padding-left: 25px;
    position: relative;
    text-decoration: none;
    transition: all ease .2s;
    width: 60px;

    &:hover {
      background: linear-gradient(0deg, $azure 0%, $azure 30%, $azure 31%, $azure 100%);
    }

    &:before {
      content: '';
      position: absolute;
      left: 0;
      width: 20px;
      height: 20px;
      background: url('../assets/arrow--dark.svg') 50% 50% no-repeat;
      transform: rotate(90deg);
    }
  }

  .pD__single__side__back {
    @include mq(small) {
      display: none;
    }
  }

  .pD__single__hero__what {
    @include ui(back);
    margin-bottom: 20px;

    
  }

  .pD__single__hero__title {
    @include outline(small);
    margin-bottom: 40px;

    @include mq(small) {
      margin-bottom: 10px;
    }
  }

  .pD__single__hero__cover {

    @include mq(small) {
      margin: 0 -20px;
      order: 2;
    }

    img {
      width: 100%;
    }
  }

  .pD__single__side {
    flex: 1;
    position: sticky;
    top: 50px;

    @include mq(small) {
      order: 3;
      flex-basis: 100%;
      position: static;
    }
  }

  .pD__single__side__container {
    margin-bottom: 40px;
  }

  .pD__single__side__container__title {
    @include ui(small);
    color: $light;
    text-transform: uppercase;
    margin-bottom: 5px;
  }

  .pD__single__side__container__content {
    @include current(small);
    color: $dark;
  }

  

  .pD__single__content {
    flex: 2;
    max-width: 100%;
    padding: 0 120px;

    @include mq(medium) {
      padding: 0 60px;
    }

    @include mq(small) {
      order: 2;
      padding: 0;
      flex-basis: 100%;
    }
  }

  .pD__single__content__excerpt {
    @include current(big);
    margin-bottom: 40px;
  }

  .pD__single__content__body {
    padding-bottom: 100px;

    @include mq(small) {
      padding-bottom: 40px;
    }
  }

</style>
